import React from 'react';
import { IAppPropsWithRoute } from '../../common/types';
import { withRouter } from 'react-router-dom';
import ClustersWidget from './ClustersWidget';
import { useDispatch } from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';


interface ClustersPageProps extends IAppPropsWithRoute {

};

const ClustersPage: React.FC<ClustersPageProps> = () =>{
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(showNavbar(true));
    }, [])

    return (
        <React.Fragment>
            <ClustersWidget />
        </React.Fragment>
    );
}

export default React.memo(withRouter(ClustersPage));